import * as actions from "../actions";
import * as actionsTypes from "../actionTypes";
import { all, fork, put, takeEvery } from "redux-saga/effects";
import CPManagersService from '../../services/cpManager.service'


function* getCpManagersList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      const search = action.payload?.search;
      const sequence = action.payload?.sequence;
      const ddList = action.payload?.ddList||'';
      let params = { page, pageSize, search, sequence, ddList };
      const response = yield CPManagersService.list(params);
      // console.log("action",action.payload);

      if (response?.data.statusCode) {
        yield put(actions.getCpManagersListSuccess(response.data));
      } else {
        yield put(actions.getCpManagersListFailure("no  data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;

    if (!error) {
      error = "network error"
    }
    yield put(actions.getCpManagersListFailure(error));
  }
}

function* getCpManagersListSaga() {
  yield takeEvery(actionsTypes.GET_CP_MANAGERS_LIST_START, getCpManagersList);
}

function* getCpContractList(action) {
  try {
    if (action.payload) {
      const page = action.payload?.pageNo;
      const pageSize = action.payload?.pageSize;
      // const search = action.payload?.search;
      // const sequence = action.payload?.sequence;
      const id = action.payload?.id;
      let params = { page, pageSize };
      const response = yield CPManagersService.contractList(id, params);
      // console.log("action",action.payload);

      if (response?.data.statusCode) {
        yield put(actions.getCpContractListSuccess(response.data));
      } else {
        yield put(actions.getCpContractListFailure("no  data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;

    if (!error) {
      error = "network error"
    }
    yield put(actions.getCpContractListFailure(error));
  }
}

function* getCpContractListSaga() {
  yield takeEvery(actionsTypes.GET_CP_CONTRACT_LIST_START, getCpContractList);
}

function* uploadCPs(action) {
  try {
    if (action.payload) {
      // console.log('upload cps',action.payload.data);
      const response = yield CPManagersService.uploadCPs(action.payload.data);
      console.log({ response })
      if (response?.data.statusCode) {
        yield put(actions.addNewCpSuccess(response.data));
      } else {
        yield put(actions.addNewCpFailure("no user data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;
    console.log(error)

    if (!error) {
      error = "network error"
    }
    yield put(actions.addNewCpFailure(error));
  }
}

function* uploadCPsSaga() {
  yield takeEvery(actionsTypes.UPLOAD_CP_MANAGERS_LIST_START, uploadCPs);
}

function* addCP(action) {
  try {
    if (action.payload) {
      const response = yield CPManagersService.createCP(action.payload);
      // if (action.payload) {
      //   let response = null;
      //   let payload = action.payload
      //   if (payload.create) {
      //     delete payload.create;
      //     response = yield CPManagersService.createCP(action.payload);
      //   } 
      // else {
      //   delete payload.create;
      //   let data = payload;
      //   console.log('data', data);
      //   delete data.id
      //   let cp_id = data.cp_id;
      //   if (data.newCpId) {
      //     data = {...data, cp_id: data.newCpId}
      //     delete data.newCpId
      //   }
      //   response = yield CPManagersService.editCp(cp_id, data);
      // }
      // if (action.payload) {
      //   const response = yield CPManagersService.createCP(action.payload);
      if (response?.data.statusCode) {
        yield put(actions.addContractSuccess(response.data));
      } else {
        yield put(actions.addContractFailure("no user data"));
      }
      // }
    }
  } catch (err) {
    let error = err?.response?.data?.message;
    console.log(error)

    if (!error) {
      error = "network error"
    }
    yield put(actions.addContractFailure(error));
  }
}

function* addCPSaga() {
  yield takeEvery(actionsTypes.ADD_NEW_CP_START, addCP);
}

function* editCP(action) {
  try {
    if (action.payload) {
      let payload = action.payload
      delete payload.create;
      let data = payload;
      // console.log('data', data);
      delete data.id
      let cp_id = data.cp_id;
      if (data.newCpId) {
        data = { ...data, cp_id: data.newCpId }
        delete data.newCpId
      }
      const response = yield CPManagersService.editCp(cp_id, data);
      if (response?.data.statusCode) {
        yield put(actions.addContractSuccess(response.data));
      } else {
        yield put(actions.addContractFailure("no user data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;
    console.log(error)

    if (!error) {
      error = "network error"
    }
    yield put(actions.addContractFailure(error));
  }
}

function* editCPSaga() {
  yield takeEvery(actionsTypes.EDIT_CP, editCP);
}

function* addContract(action) {
  try {
    const {
      payload: {
        start_date,
        end_date,
        sub_license,
        cont_sig_doc,
        rights_letter_doc,
        cont_dep_platforms,
        description,
        id,
        create,
        account_no, account_title, bank_name, branch_address, branch_code, iban, swift_code, cp_profile_id, title
      }
    } = action
    let response = null;
    const data = new FormData()
    if(!create) data.append('id', id);
    data.append('cont_sig_doc', cont_sig_doc)//file
    data.append('rights_letter_doc', rights_letter_doc)//file
    data.append('cont_dep_platforms', cont_dep_platforms)
    data.append('description', description)
    data.append('title', title)
    data.append('start_date', start_date)
    data.append('end_date', end_date)
    data.append('sub_license', sub_license)
    data.append('cp_profile_id', cp_profile_id)

    data.append('account_no', account_no)
    data.append('account_title', account_title)
    data.append('branch_address', branch_address)
    data.append('bank_name', bank_name)
    data.append('branch_code', branch_code)
    data.append('iban', iban)
    data.append('swift_code', swift_code)

    if(create) response = yield CPManagersService.createContract(cp_profile_id, data);
    else response = yield CPManagersService.editContract(cp_profile_id, data);
    console.log('response: ', response.data);

    if (response?.data.statusCode) {
      yield put(actions.addContractSuccess(response.data));
    } else {
      yield put(actions.addContractFailure("no user data"));
    }

  } catch (err) {
    let error = err?.response?.data?.message;

    if (!error) {
      error = "network error"
    }
    yield put(actions.addContractFailure(error));
  }
}


function* addContractSaga() {
  yield takeEvery(actionsTypes.ADD_CONTRACT_START, addContract);
}


function* getCpData(action) {
  try {
    if (action.payload) {
      const id = action.payload?.id;

      const response = yield CPManagersService.getCP(id);

      // console.log(response.data);

      if (response?.data.statusCode) {
        yield put(actions.getCpSuccess(response.data));
      } else {
        yield put(actions.getCpFailure("no user data"));
      }
    }
  } catch (err) {
    let error = err?.response?.data?.message;
    if (!error)
      yield put(actions.getCpFailure("no user data"));
  }
}


function* getCPSaga() {
  yield takeEvery(actionsTypes.GET_CP_START, getCpData);
}

export function* CPManagersSaga() {
  yield all([
    fork(getCpManagersListSaga),
    fork(getCpContractListSaga),
    fork(addContractSaga),
    fork(addCPSaga),
    fork(editCPSaga),
    fork(getCPSaga),
    fork(uploadCPsSaga),
  ]);
}
